import type { ComponentType } from 'react';
import { safeComponent } from '@atlassian/jira-issue-view-common-utils/src/safe-component/index.tsx';
import { PreviewCommentContent, type Props } from './view.tsx';

// PreviewCommentContent doesn't not have any usage of intl
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default safeComponent()(PreviewCommentContent) as ComponentType<Props>;
